export default __webpack_public_path__ + "static/media/search.c37cf968.svg";